import {DocketSelectorEntityModel} from "../docket-selector-entity-model.service";
import {AbstractEditPage} from "../../../framework/entity/edit/edit-page/abstract-edit-page";
import {provideEntityModel} from "@fedeltapointofsale/data-client";
import {ChangeDetectorRef, Component} from "@angular/core";
import {FUIResponsiveService} from "@fedeltapointofsale/ui";

@Component({
    selector: "wbo-docket-selector-edit-page",
    templateUrl: "./docket-selector-edit-page.component.html",
    providers: [provideEntityModel(DocketSelectorEntityModel)]
})
export class DocketSelectorEditPageComponent extends AbstractEditPage {
    constructor(public model: DocketSelectorEntityModel,
                changeDetectorRef: ChangeDetectorRef,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, responsiveService);
    }
}
